import React, { useState, useRef, useEffect } from 'react';
import { FiChevronDown, FiSearch } from 'react-icons/fi';
import { COUNTRY_CODE_PHONE } from '../data/countryCodes';

const FLAG_CDN = 'https://flagcdn.com';
function FlagIcon({ code, className }) {
  if (!code || code.length !== 2) return null;
  const iso = code.toLowerCase();
  return (
    <img
      src={`${FLAG_CDN}/w40/${iso}.png`}
      alt=""
      className={className}
      loading="lazy"
      width={24}
      height={18}
    />
  );
}

const COUNTRY_NAMES = [
  'Canada',
  'United States',
  'India',
  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia, Plurinational State of bolivia',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
 
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'China',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo',
  'Congo, The Democratic Republic of the Congo',
  'Cook Islands',
  'Costa Rica',
  "Côte d'Ivoire",
  'Croatia',
  'Cuba',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern Territories',
  'Gabon',
  'Gambia',
  'Georgia',
  'Germany',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and Mcdonald Islands',
  'Holy See (Vatican City State)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
 
  'Indonesia',
  'Iran, Islamic Republic of Persian Gulf',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  "Campione d'Italia",
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea, Democratic People's Republic of Korea",
  'Korea, Republic of South Korea',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libyan Arab Jamahiriya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of Micronesia',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestinian Territory, Occupied',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Romania',
  'Russia',
  'Rwanda',
  'Reunion',
  'Saint Barthelemy',
  'Saint Helena, Ascension and Tristan Da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Sudan',
  'South Georgia and the South Sandwich Islands',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Svalbard and Jan Mayen',
  'Eswatini',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of Tanzania',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
 
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of Venezuela',
  'Vietnam',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Yemen',
  'Zambia',
  'Zimbabwe',
];

const COUNTRIES = COUNTRY_NAMES.map((name) => {
  const { code = '', phone = '' } = COUNTRY_CODE_PHONE[name] ?? {};
  return { value: name, label: name, code, phone };
});

export function CountrySelect({
  value,
  onChange,
  id = 'country',
  includeAllOption = false,
  allOptionLabel = 'All countries',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const containerRef = useRef(null);
  const searchInputRef = useRef(null);

  const selectedCountry = COUNTRIES.find((c) => c.label === value);
  const displayText =
    selectedCountry?.label ?? (includeAllOption ? allOptionLabel : 'Select your country');
  const selectedPhone = selectedCountry?.phone ?? '';

  const filteredCountries = COUNTRIES.filter((c) =>
    c.label.toLowerCase().includes(search.trim().toLowerCase())
  );

  const normalizedSearch = search.trim().toLowerCase();
  const showAllOption =
    includeAllOption &&
    (!normalizedSearch || allOptionLabel.toLowerCase().includes(normalizedSearch));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen) {
      setSearch('');
      setTimeout(() => searchInputRef.current?.focus(), 0);
    }
  }, [isOpen]);

  const handleSelect = (countryValue) => {
    onChange(countryValue);
    setSearch('');
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className="relative w-full">
      <button
        type="button"
        id={id}
        onClick={() => setIsOpen(!isOpen)}
        className="h-10 w-full rounded-lg px-4 py-3 border border-[#ECECEC] focus:outline-none focus:border-gray-300 bg-white flex items-center justify-between gap-2 text-left text-[#212121]  transition-colors"
      >
        <span className={`flex flex-1 items-center gap-2 min-w-0 ${!value ? 'text-[#7D7D7D] font-normal' : ''}`}>
          {selectedCountry?.code && (
            <span className="shrink-0 w-6 h-6 overflow-hidden rounded-sm flex items-center justify-center bg-gray-100">
              <FlagIcon code={selectedCountry.code} className="w-6 h-6 object-cover" />
            </span>
          )}
          <span className="truncate flex-1 min-w-0">{displayText}</span>
          {selectedPhone && <span className="text-[#7D7D7D] shrink-0 pl-2">{selectedPhone}</span>}
        </span>
        <FiChevronDown
          size={20}
          className={`text-[#7D7D7D] shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 right-0 mt-1 z-50 rounded-2xl overflow-hidden border border-[#FDE8E0] shadow-lg bg-white flex flex-col max-h-80">
          <div className="p-2 border-b border-[#FDE8E0] bg-white shrink-0">
            <div className="flex items-center gap-2 rounded-xl border-2 border-[#FDE8E0] bg-white px-3 py-2">
              <FiSearch size={18} className="text-[#7D7D7D] shrink-0" />
              <input
                ref={searchInputRef}
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.stopPropagation()}
                placeholder="Search country"
                className="w-full bg-transparent text-sm text-[#212121] placeholder:text-[#7D7D7D] focus:outline-none"
              />
            </div>
          </div>
          <div
            className="max-h-64 overflow-y-auto py-1 divide-y divide-gray-100"
            style={{ scrollbarColor: 'rgb(229 231 235) white' }}
          >
            {filteredCountries.length === 0 && !showAllOption ? (
              <div className="px-4 py-3 text-sm text-[#7D7D7D]">No country found</div>
            ) : (
              <>
                {showAllOption ? (
                  <button
                    type="button"
                    onClick={() => handleSelect('')}
                    className={`w-full px-4 py-3 flex items-center gap-3 text-left text-sm hover:bg-[#FAB9A2] focus:bg-[#FAB9A2] focus:outline-none transition-colors ${
                      value === '' ? 'bg-[orange-50] text-[#7D7D7D]' : 'text-[#7D7D7D]'
                    }`}
                  >
                    <span className="shrink-0 w-6 h-4" />
                    <span className="flex-1 min-w-0 truncate">{allOptionLabel}</span>
                    <span className="text-[#7D7D7D] shrink-0">{''}</span>
                  </button>
                ) : null}

                {filteredCountries.map((country) => (
                  <button
                    key={country.label}
                    type="button"
                    onClick={() => handleSelect(country.label)}
                    className={`w-full px-4 py-3 flex items-center gap-3 text-left text-sm hover:bg-[#FAB9A2] focus:bg-[#FAB9A2] focus:outline-none transition-colors ${
                      value === country.label
                        ? 'bg-[orange-50] text-[#7D7D7D]'
                        : 'text-[#7D7D7D]'
                    }`}
                  >
                    {country.code ? (
                      <span className="shrink-0 w-6 h-6 overflow-hidden rounded-sm flex items-center justify-center bg-gray-100">
                        <FlagIcon code={country.code} className="w-6 h-6 object-cover" />
                      </span>
                    ) : (
                      <span className="shrink-0 w-6 h-4" />
                    )}
                    <span className="flex-1 min-w-0 truncate">{country.label}</span>
                    <span className="text-[#7D7D7D] shrink-0">{country.phone ?? ''}</span>
                  </button>
                ))}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
